module.exports = __webpack_public_path__ + "2886d33bc6e234d7bf774e98ca142de9.MP3";